/**
 * FormikComponent
 *
 * Renders a set of toggle switches for promotional communication types using Formik context.
 *
 * Features:
 * - Dynamically generates switches for keys in `values.communicationType` that start with "promo"
 * - Uses `labelMap` for custom labels, falls back to key name
 * - Updates Formik field value on toggle
 * - Supports disabling all switches via the `disabled` prop
 */

import { useFormikContext } from 'formik';

const FormikComponent = ({ labelMap = {}, disabled = false }) => {
    const { values, setFieldValue } = useFormikContext();
    return (
        <div className="fv-row fv-plugins-icon-container">
            <div className="d-flex flex-column justify-content-between gap-3">
                {Object.keys(values.communicationType)
                    .filter(key => key.startsWith("promo"))
                    .map(option => (
                        <div key={option} className="d-flex justify-content-between">
                            <label
                                htmlFor={`promotionalCommunicationType-${option}`}
                                className="form-check-label fs-6 fw-semibold"
                            >
                                {labelMap[option] || option.replace("promo_", "")}
                            </label>
                            <div className="form-check form-switch">
                                <input
                                    type="checkbox"
                                    id={`promotionalCommunicationType-${option}`}
                                    name="communicationType"
                                    value={option}
                                    checked={values.communicationType[option] === "yes"}
                                    onChange={(e) => {
                                        const { checked } = e.target;
                                        setFieldValue("communicationType", {
                                            ...values.communicationType,
                                            [option]: checked ? "yes" : "no"
                                        });
                                    }}
                                    className={`form-check-input ${values.communicationType[option] === "yes" ? "text-success border-success bg-success" : "  "
                                        }`}
                                    disabled={disabled}
                                />
                            </div>
                        </div>
                    ))}
            </div>
        </div>
    );
};

export default FormikComponent;
